export function groupTrainingExercises(exercises = [], options = []) {
	const phaseId = (value) =>
		/^\d+$/.test(String(value ?? "").trim()) ? Number(value) : null;
	const build = (id, label, rows, unassigned = false) => ({
		id,
		label,
		unassigned,
		exercises: [...rows].sort((a, b) => (a.sorting || 0) - (b.sorting || 0)),
		duration: rows.reduce((sum, row) => sum + (row.duration || 0), 0),
	});
	const phases = options.map((p) =>
		build(
			p.value,
			p.label,
			exercises.filter((e) => phaseId(e.phase) === p.value),
		),
	);
	const unknown = exercises.filter(
		(e) => !options.some((p) => p.value === phaseId(e.phase)),
	);
	if (unknown.length)
		phases.push(build("unassigned", "Fase da assegnare", unknown, true));
	return phases;
}
